import {
  AnganaDutta,
  AnitDebnath,
  AvroGhosh,
  BibaswasMukherjee,
  BhaskarDe,
  SankhajitLalMitra,
  SudipPalit,
  SujitChakraborty,
  TaniaSenChatterjee,
  SatabdiAdhikary,
} from ".";

const teamMembers = [
  {
    name: "Sujit Chakraborty",
    experience: 37,
    designation: "Designated Partner",
    details: "Sujit Chakraborty has worked for over 37 years...",
    image: SujitChakraborty,
    description:
      "A distinguished individual, holds a B.Sc (Hons), LLB, and LLM degree. With an illustrious career spanning 37 years in the Kolkata Police, he has held various esteemed positions. Notably, he served as Officer in Charge of 8 police stations and attained the rank of Assistant Commissioner of Police. His tenure in the Detective department showcased exceptional proficiency in crime detection and investigation of many critical cases in Kolkata. He earned numerous accolades from the Commissioner of Police Kolkata, Judiciary, and the President of India, including the prestigious Indian Police Medal for meritorious service. Additionally, Mr. Chakraborty's commitment to global peace was demonstrated through his service in the United Nations Peacekeeping Mission in Kosovo.",
    extra:
      "Particularly noted for his prowess in crime detection during his tenure in the detective department.",
  },
  {
    name: "Angana Dutta",
    experience: 5,
    designation: "Designated Partner",
    details:
      "Angana Dutta, a Partner Director and graduate of Symbiosis Law School...",
    image: AnganaDutta,
    description:
      "Angana Dutta, a Partner Director and graduate of Symbiosis Law School, Hyderabad, brings over three years of dedicated legal experience with a strong focus on High Court writ practice in Calcutta, complemented by a comprehensive understanding of commercial and intellectual property law.",
    extra: "A Partner Director and graduate of Symbiosis Law School",
  },
  {
    name: "Bhaskar De",
    experience: 25,
    designation: "Senior Legal Advisor",
    details:
      "Advocate Bhaskar De is a highly experienced legal professional with over 25 years...",
    image: BhaskarDe,
    description:
      "Advocate Bhaskar De is a highly experienced legal professional with over 25 years of distinguished practice in litigation. His extensive expertise spans a wide range of legal matters, with a particular focus on criminal law. Throughout his career, he has consistently delivered relief to clients in some of the most complex and critical cases. For the past six years, Advocate De has been honored with the designation of Senior Counsel by the Government of India. He practices in various High Courts and District Courts across India, representing clients in diverse legal matters with the utmost commitment and integrity.",
    extra:
      "Representing clients in diverse legal matters with the utmost commitment and integrity.",
  },
  {
    name: "Sudip Palit",
    experience: 24,
    designation: "Senior Legal Advisor",
    details:
      "Advocate Sudip Palit brings over 24 years of distinguished experience...",
    image: SudipPalit,
    description:
      "Advocate Sudip Palit brings over 24 years of distinguished experience in the legal profession, specializing in litigation and providing strategic legal solutions to clients in complex and critical cases. He has been appointed as a Senior Counsel by the Government of India, a position he has been holding since the last 12 years. Advocate Palit practices across various High Courts and District Courts, and has also represented clients in the Supreme Court of India. His expertise spans a wide range of legal domains, including civil, corporate, land, and banking law, as well as drafting agreements and other facets of legal practice. His profound knowledge and extensive experience make him a trusted advisor and advocate for his clients.",
    extra:
      "Appointed as a Senior Counsel by the Government of India, a position he has been holding since the last 12 years.",
  },
  {
    name: "Bibaswan Mukherjee",
    experience: 7,
    // experience: "Expertise in Cyber Law",
    designation: "Senior Legal Associate",
    details:
      "Bibaswan Mukherjee has served in cyber law and forensics department...",
    image: BibaswasMukherjee,
    description:
      "Mr. Bibaswan Mukherjee, holding BA LLB and LLM degrees specializing in corporate and business law, possesses specialized expertise in cyber law and cyber forensics. With a robust legal background, he has practiced at the High Court Calcutta and other esteemed High Courts. Mr. Mukherjee is recognized as a proficient advocate, having secured landmark judgments at a remarkably young age, showcasing his exceptional talent and dedication to the legal profession.",
    extra:
      "Specialized knowledge in cyber law and cyber forensics, reflecting a keen understanding of digital legal matters.",
  },
  {
    name: "Sankhajit Lal Mitra",
    experience: 8,
    designation: "Senior Legal Associate",
    details:
      "Sankhajit Lal Mitra is a seasoned advocate with over 10 years of experience...",
    image: SankhajitLalMitra,
    description:
      "Sankhajit Lal Mitra is a seasoned advocate with over 10 years of experience in criminal matters, practicing exclusively at the High Court at Calcutta. Having trained under Senior Advocate Mr. Sekhar Kumar Basu for over a decade, he has advised and represented notable individuals and entities, including those in the Bollywood and Tollywood film industries.",
    extra:
      "A seasoned advocate with over 10 years of experience in criminal matters",
  },
  {
    name: "Tania Sen Chatterjee",
    experience: 6,
    designation: "Legal Associate",
    details:
      "Mrs. Tania Sen Chatterjee holds a BA LLB degree from North Bengal University...",
    image: TaniaSenChatterjee,
    description:
      "Mrs. Tania Sen Chatterjee holds a BA LLB degree from North Bengal University (2018) and specializes in both Civil and Criminal Cases, practicing in various district courts in North Bengal and Kolkata. Her dedication and detailed knowledge in legal drafting and case handling make her a valuable asset.",
    extra: "Specializes in both Civil and Criminal Cases",
  },
  {
    name: "Anit Debnath",
    experience: 3,
    designation: "Legal Associate",
    details: "Holding a BALLB from Calcutta University...",
    image: AnitDebnath,
    description:
      "Holding a BALLB from Calcutta University and possessing four years of practice, this advocate specializes in Criminal Law, offering dedicated legal services in this field.",
    extra: "Offering dedicated legal services in this field.",
  },
  {
    name: "Avro Ghosh",
    experience: 1,
    designation: "Legal Associate",
    details:
      "I'm Avro Ghosh, a Criminal Advocate. I practice primarily at the Alipore Criminal Court...",
    image: AvroGhosh,
    description:
      "I'm Avro Ghosh, a Criminal Advocate. I practice primarily at the Alipore Criminal Court, and I also handle cases in other district courts. I completed my BA LLB from Calcutta University in 2024, graduating with 82% marks. My focus is exclusively on criminal law, and I'm dedicated to providing effective legal representation to my clients.",
    extra:
      "I prioritize quality in my work and have established strong professional connections.",
  },
  {
    name: "Satabdi Adhikary",
    experience: 1,
    designation: "Legal Associate",
    details:
      "Satabdi Adhikary, a 25-year-old graduate with a strong academic background...",
    image: SatabdiAdhikary,
    description:
      "Satabdi Adhikary, a 25-year-old graduate with a strong academic background, holds an LL.B (2024) and has cleared the AIBE (2025), becoming a certified advocate. Passionate about justice, she is dedicated to upholding the values of the legal system.",
    extra: "Dedicated to upholding the values of the legal system...",
  },
];

export { teamMembers };
